import React, { useState } from "react";
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Button,
  Alert,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

// hooks
import { useRedux } from "../../../hooks/index";

// components
import AudioCallModal from "../../../components/AudioCallModal";
import VideoCallModal from "../../../components/VideoCallModal";
import AddPinnedTabModal from "../../../components/AddPinnedTabModal";

// interface
import { PinTypes } from "../../../data/chat";

// actions
import { changeSelectedChat, getLastGroupChatInfoOfMember } from "../../../redux/actions";
import { setActivePostId2 } from "../../../redux/workplace/wpActions";

// constants
import { STATUS_TYPES, ONLINE_STATUS } from "../../../constants";
import { UserTypes } from "api";
import UserAvatar from "components/UserAvatar";
import classNames from "classnames";
import { Utils } from "helpers/utils";
import { createSelector } from "reselect";
import { Const } from "const";
interface ProfileImageProps {
  chatUserDetails: any;
  activeChatRoom: any;
  onCloseConversation: () => any;
  onOpenUserDetails: () => any;
  isChannel: boolean;
}
const ProfileImage = ({
  chatUserDetails,
  activeChatRoom,
  onCloseConversation,
  onOpenUserDetails,
  isChannel,
}: ProfileImageProps) => {
  //  console.log('chatUserDetails:', chatUserDetails);
  // const fullName = !isChannel
  //   ? chatUserDetails.firstName
  //     ? `${chatUserDetails.firstName} ${chatUserDetails.lastName}`
  //     : "-"
  //   : chatUserDetails.name;

  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state: any) => state.Layout,
    (profile2, layout) => ({
      curUserType: profile2.userType,
      isInFrame: layout.isInFrame,
    })
  );
  const { curUserType, isInFrame } = useAppSelector(storeData);

  const hasUserDetails = chatUserDetails.contactType;

  const fnGetFullName = () => {
    if (!hasUserDetails) return activeChatRoom?.fullName;

    if (chatUserDetails.displayName) return chatUserDetails.displayName;
    if (chatUserDetails.is2s) {
      return chatUserDetails.firstName ? `${chatUserDetails.firstName} ${chatUserDetails.lastName}` : "-";
    } else {
      return !isChannel
        ?
        chatUserDetails.firstName ? `${chatUserDetails.firstName} ${chatUserDetails.lastName}` : "-"
        :
        chatUserDetails.name;
    }
  }

  // const fnGetShortName = () => {
  //   // console.log('chatUserDetails:', chatUserDetails);
  //   if (chatUserDetails.is2s) {
  //     return chatUserDetails.firstName
  //       ? `${chatUserDetails.firstName.charAt(0)}${chatUserDetails.lastName.charAt(0)}`
  //       : "-";
  //   } else {
  //     return !isChannel
  //       ? chatUserDetails.firstName
  //         ? `${chatUserDetails.firstName.charAt(0)}${chatUserDetails.lastName.charAt(0)}`
  //         : "-"
  //       : "#";
  //   }
  // }

  // const fullName = !isChannel
  //   ?
  //   chatUserDetails.firstName ? `${chatUserDetails.firstName} ${chatUserDetails.lastName}` : "-"
  //   :
  //   chatUserDetails.name;
  const fullName = fnGetFullName();


  // const shortName = !isChannel
  //   ? chatUserDetails.firstName
  //     ? `${chatUserDetails.firstName.charAt(
  //       0
  //     )}${chatUserDetails.lastName.charAt(0)}`
  //     : "-"
  //   : "#";
  // const shortName = fnGetShortName();

  const colors = [
    "bg-primary",
    "bg-danger",
    "bg-info",
    "bg-warning",
    "bg-secondary",
    "bg-pink",
    "bg-purple",
  ];
  const [color] = useState(Math.floor(Math.random() * colors.length));

  const fnGetOnlineFlag = () => {
    if (!hasUserDetails) return false;

    if (chatUserDetails.is2s) {
      return chatUserDetails.status && chatUserDetails.status == ONLINE_STATUS.ACTIVE;
    } else {
      return chatUserDetails.status && chatUserDetails.status === STATUS_TYPES.ACTIVE;
    }
  }

  // const isOnline =
  //   chatUserDetails.status && chatUserDetails.status === STATUS_TYPES.ACTIVE;
  const isOnline = fnGetOnlineFlag();

  // const members = (chatUserDetails.members || []).length;

  const fnTextLine2 = () => {
    if (!hasUserDetails) return "กลุ่มแชท";

    if (chatUserDetails.is2s) {
      switch (chatUserDetails.contactType) {
        case UserTypes.Customer: return "ลูกค้า " + chatUserDetails.name;
        case UserTypes.Employee: return "พนักงาน " + chatUserDetails.name;
        //case UserTypes.Group: return "กลุ่มแชท " + chatUserDetails.memberCount + " คน";
        case UserTypes.Group: return "กลุ่มแชท";
      }
      return "";
    } else {
      return "";
      //return isChannel ? `${(chatUserDetails.members || []).length} Members` : chatUserDetails.status;
      // return (chatUserDetails.members || []).length;
    }
  }
  const line2text = fnTextLine2();

  const isDark = Utils.IsDarkTheme();

  let newTab: Window | null = null;
  // Function to open a URL in a new tab and reuse the same tab for subsequent calls
  function openUrlInSameTab(url: string): void {
    const tabName = "myUniqueTabName"; // Unique name for the tab
    if (!newTab || newTab.closed) {
      // If the tab doesn't exist or is closed, open a new one
      newTab = window.open(url, tabName);
    } else {
      // If the tab is already open, update its location
      newTab.location.href = url;
      newTab.focus();
    }
  }
  const onClickGroupIcon = async () => {
    try {
      if (curUserType === UserTypes.Employee) {
        const companyId = hasUserDetails ? chatUserDetails.companyId : activeChatRoom?.companyId;
        if (companyId/*chatUserDetails.companyId*/) {
          const erpUrl = Const.ERP_CUSTOMER_PAGE.replaceAll('[CustomerId]', companyId/*chatUserDetails.companyId*/);
          openUrlInSameTab(erpUrl);
        } else {
          alert('ยังไม่ได้จับคู่บริษัท');
        }
      }
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  return (
    <div className="d-flex align-items-center">
      {!isInFrame && (
        <div className="flex-shrink-0 d-block d-md-none me-2 ">
          <Link
            to="#"
            onClick={onCloseConversation}
            className={classNames("user-chat-remove text-muted font-size-24 p-2", { "user-chat-remove-dark": isDark })}
          >
            <i id="uh-back" className="bx bx-chevron-left align-middle"></i>
          </Link>
        </div>
      )}
      <div className="flex-grow-1 overflow-hidden ">
        <div className="d-flex align-items-center ">
          <div
            onClick={onClickGroupIcon}
            className={classnames(
              "flex-shrink-0",
              "chat-user-img",
              "align-self-center",
              "me-3",
              "ms-0",
              "hand",
              { online: isOnline }
            )}
          >
            {(chatUserDetails.profileImage ?? activeChatRoom?.profileImage) ? (
              <>
                <img
                  src={(chatUserDetails.profileImage ?? activeChatRoom?.profileImage)}
                  className="rounded-circle avatar-sm"
                  alt=""
                />
                <span
                  className={classnames(
                    "user-status",
                    {
                      "bg-success":
                        chatUserDetails.status === STATUS_TYPES.ACTIVE,
                    },
                    {
                      "bg-warning":
                        chatUserDetails.status === STATUS_TYPES.AWAY,
                    },
                    {
                      "bg-danger":
                        chatUserDetails.status === STATUS_TYPES.DO_NOT_DISTURB,
                    }
                  )}
                ></span>
              </>
            ) : (
              <UserAvatar
                profileImage={chatUserDetails.profileImage ?? activeChatRoom?.profileImage}
                bgColor={chatUserDetails.bgColor ?? activeChatRoom?.bgColor}
                foreColor={chatUserDetails.foreColor ?? activeChatRoom?.foreColor}
                abbrName={chatUserDetails.abbrName ?? activeChatRoom?.abbrName}
                size="sm"
              />
            )}
          </div>
          <div className="flex-grow-1 overflow-hidden">
            <h6 className="text-truncate mb-0 font-size-18">
              <Link
                to="#"
                onClick={onOpenUserDetails}
                className="user-profile-show text-reset"
              >
                {fullName}
              </Link>
            </h6>
            <p className="text-truncate text-muted mb-0">
              <small>{line2text}</small>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Search = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle
        color="none"
        className="btn nav-btn dropdown-toggle"
        type="button"
      >
        <i className="bx bx-search"></i>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu p-0 dropdown-menu-end dropdown-menu-lg">
        <div className="search-box p-2">
          <Input type="text" className="form-control" placeholder="Search.." />
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};
interface MoreProps {
  onOpenAudio: () => void;
  onOpenVideo: () => void;
  onDelete: () => void;
  isArchive: boolean;
  onToggleArchive: () => void;
}
const More = ({
  onOpenAudio,
  onOpenVideo,
  onDelete,
  isArchive,
  onToggleArchive,
}: MoreProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    null
    // <Dropdown isOpen={dropdownOpen} toggle={toggle}>
    //   <DropdownToggle color="none" className="btn nav-btn" type="button">
    //     <i className="bx bx-dots-vertical-rounded"></i>
    //   </DropdownToggle>
    //   <DropdownMenu className="dropdown-menu-end">
    //     <DropdownItem
    //       className="d-flex justify-content-between align-items-center d-md-none user-profile-show"
    //       to="#"
    //     >
    //       View Profile <i className="bx bx-user text-muted"></i>
    //     </DropdownItem>
    //     <DropdownItem
    //       className="d-flex justify-content-between align-items-center d-md-none"
    //       to="#"
    //       onClick={onOpenAudio}
    //     >
    //       Audio <i className="bx bxs-phone-call text-muted"></i>
    //     </DropdownItem>
    //     <DropdownItem
    //       className="d-flex justify-content-between align-items-center d-md-none"
    //       to="#"
    //       onClick={onOpenVideo}
    //     >
    //       Video <i className="bx bx-video text-muted"></i>
    //     </DropdownItem>
    //     <DropdownItem
    //       className="d-flex justify-content-between align-items-center"
    //       to="#"
    //       onClick={onToggleArchive}
    //     >
    //       {isArchive ? (
    //         <>
    //           Un-Archive <i className="bx bx-archive-out text-muted"></i>
    //         </>
    //       ) : (
    //         <>
    //           Archive <i className="bx bx-archive text-muted"></i>
    //         </>
    //       )}
    //     </DropdownItem>
    //     <DropdownItem
    //       className="d-flex justify-content-between align-items-center"
    //       to="#"
    //     >
    //       Muted <i className="bx bx-microphone-off text-muted"></i>
    //     </DropdownItem>
    //     <DropdownItem
    //       className="d-flex justify-content-between align-items-center"
    //       to="#"
    //       onClick={onDelete}
    //     >
    //       Delete <i className="bx bx-trash text-muted"></i>
    //     </DropdownItem>
    //   </DropdownMenu>
    // </Dropdown>
  );
};

interface PinnedAlertProps {
  onOpenPinnedTab: () => void;
}
const PinnedAlert = ({ onOpenPinnedTab }: PinnedAlertProps) => {
  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  return (
    <Alert
      color="warning"
      isOpen={visible}
      toggle={onDismiss}
      className="topbar-bookmark p-1 px-3 px-md-4 pe-md-5 pe-5 alert-dismiss-custom"
      role="alert"
      style={{ display: "none" }}
    >
      <div className="d-flex align-items-start bookmark-tabs">
        <div className="tab-list-link">
          <Link to="#" className="tab-links" onClick={onOpenPinnedTab}>
            <i className="ri-pushpin-fill align-middle me-1"></i> 10 Pinned
          </Link>
        </div>
        <div id="add-bookmark">
          <Link to="#" className="tab-links border-0 px-3">
            <i className="ri-add-fill align-middle"></i>
          </Link>
        </div>
        {/* <UncontrolledTooltip target="add-bookmark" placement="bottom">
          Add Bookmark
        </UncontrolledTooltip> */}
      </div>
    </Alert>
  );
};
interface UserHeadProps {
  chatUserDetails: any;
  activeChatRoom: any;
  pinnedTabs: Array<PinTypes>;
  onOpenUserDetails: () => void;
  onDelete: () => void;
  isChannel: boolean;
  onToggleArchive: () => void;
  onClickSearchIcon: () => void;
}
const UserHead = ({
  chatUserDetails,
  activeChatRoom,
  pinnedTabs,
  onOpenUserDetails,
  onClickSearchIcon,
  onDelete,
  isChannel,
  onToggleArchive,
}: UserHeadProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state: any) => state.Chats,
    (profile2, chat) => ({
      curUserType: profile2.userType,
      selectedChat: chat.selectedChat,
      isOpenUserDetailsTab: chat.isOpenUserDetailsTab,
    })
  );
  const { curUserType, selectedChat, isOpenUserDetailsTab } = useAppSelector(storeData);
  /*
    video call modal
    */
  const [isOpenVideoModal, setIsOpenVideoModal] = useState<boolean>(false);
  const onOpenVideo = () => {
    setIsOpenVideoModal(true);
  };
  const onCloseVideo = () => {
    setIsOpenVideoModal(false);
  };

  /*
        audio call modal
    */
  const [isOpenAudioModal, setIsOpenAudioModal] = useState<boolean>(false);
  const onOpenAudio = () => {
    setIsOpenAudioModal(true);
  };
  const onCloseAudio = () => {
    setIsOpenAudioModal(false);
  };

  /*
  pinned tab modal
  */
  const [isOpenPinnedTabModal, setIsOpenPinnedTabModal] =
    useState<boolean>(false);
  const onOpenPinnedTab = () => {
    setIsOpenPinnedTabModal(true);
  };
  const onClosePinnedTab = () => {
    setIsOpenPinnedTabModal(false);
  };

  /*
  mobile menu chat conversation close
  */
  const onCloseConversation = () => {
    if (selectedChat) {
      dispatch(getLastGroupChatInfoOfMember(selectedChat));
    }
    //console.log('Dashboard.Conversationuser.UserHead.selectedChat = null');
    dispatch(changeSelectedChat(null));
    dispatch(setActivePostId2(null, null, null, null, null, "Clear on close conversation"));
  };



  return (
    <div className="p-3 p-md-4 user-chat-topbar">
      <Row className="align-items-center">
        <Col className="d-flex justify-content-between">
          <div>
            <ProfileImage
              chatUserDetails={chatUserDetails}
              activeChatRoom={activeChatRoom}
              onCloseConversation={onCloseConversation}
              onOpenUserDetails={onOpenUserDetails}
              isChannel={isChannel}
            />
          </div>
          <div>
            <ul className="list-inline user-chat-nav text-end mb-0">
              <li className="list-inline-item  ">
                {/* <Search /> */}
              </li>

              <li className="list-inline-item d-md-inline-block ">
                <button
                  onClick={onClickSearchIcon}
                  type="button"
                  className="btn nav-btn user-profile-show"
                >
                  <i className="fas fa-search"></i>
                </button>
              </li>

              <li className="list-inline-item d-none d-md-inline-block ">
                <button
                  onClick={onOpenUserDetails}
                  type="button"
                  className="btn nav-btn user-profile-show"
                >
                  <i className="bx bxs-info-circle"></i>
                </button>
              </li>

              <li className="list-inline-item d-none d-md-inline-block ">
                <More
                  onOpenAudio={onOpenAudio}
                  onOpenVideo={onOpenVideo}
                  onDelete={onDelete}
                  isArchive={chatUserDetails.isArchived}
                  onToggleArchive={onToggleArchive}
                />
              </li>
            </ul>
          </div>

        </Col>
      </Row>
      <Row className="align-items-center" style={{ display: "none" }}>

        <Col sm={10} className="col-11" >
          <ProfileImage
            chatUserDetails={chatUserDetails}
            activeChatRoom={activeChatRoom}
            onCloseConversation={onCloseConversation}
            onOpenUserDetails={onOpenUserDetails}
            isChannel={isChannel}
          />
        </Col>


        <Col sm={2} className="col-1">
          <ul className="list-inline user-chat-nav text-end mb-0">
            <li className="list-inline-item  ">
              {/* <Search /> */}
            </li>

            <li className="list-inline-item d-none d-md-inline-block me-1 ms-0">
              <button
                onClick={onClickSearchIcon}
                type="button"
                className="btn nav-btn user-profile-show"
              >
                <i className="fas fa-search"></i>
              </button>
            </li>

            <li className="list-inline-item d-none d-md-inline-block me-2 ms-0">
              <button
                onClick={onOpenUserDetails}
                type="button"
                className="btn nav-btn user-profile-show"
              >
                <i className="bx bxs-info-circle"></i>
              </button>
            </li>

            <li className="list-inline-item d-none d-md-inline-block me-2 ms-0">
              <More
                onOpenAudio={onOpenAudio}
                onOpenVideo={onOpenVideo}
                onDelete={onDelete}
                isArchive={chatUserDetails.isArchived}
                onToggleArchive={onToggleArchive}
              />
            </li>
          </ul>
        </Col>

      </Row>
      <PinnedAlert onOpenPinnedTab={onOpenPinnedTab} />
      {isOpenAudioModal && (
        <AudioCallModal
          isOpen={isOpenAudioModal}
          onClose={onCloseAudio}
          user={chatUserDetails}
        />
      )}
      {isOpenVideoModal && (
        <VideoCallModal
          isOpen={isOpenVideoModal}
          onClose={onCloseVideo}
          user={chatUserDetails}
        />
      )}
      {isOpenPinnedTabModal && (
        <AddPinnedTabModal
          isOpen={isOpenPinnedTabModal}
          onClose={onClosePinnedTab}
          pinnedTabs={pinnedTabs}
        />
      )}
    </div>
  );
};

export default UserHead;
